export const SET_ORG_DATA = "SET_ORG_DATA"

export const SET_ORG_LOADING = "SET_ORG_LOADING"
export const SET_ORG_ERROR = "SET_ORG_ERROR"
